import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import ItemWrap from '../components/item-wrap';
import classnames from 'classnames';
import useProps from '../../_util/useProps';

export default function() {
    const [list, setList] = useState([]);
    const [value, setValue] = useState(null);

    const { map, TextEnum } = useProps();

    useEffect(() => {
        const { imageryProvider, options, style } = map.baseMap;
        if (options?.length) {
            setList(options);
        }

        if (imageryProvider && style) {
            setValue(map.baseMap.getValue());
        }
    }, []);

    // 切换
    const onChange = (item, val) => {
        setValue({ ...val, value: `${item.value}_${val.value}` });
        map.baseMap.setValue(item.value, val.value);
    };

    const content = () => {
        return (
            <div className={classnames('cs-map-base-map-switch-list-wrap')}>
                <div className={classnames('base-map-switch-list-title')}>
                    {TextEnum.chooseBaseMapText}
                </div>
                <div className={classnames('base-map-switch-list')}>
                    {list.map(item => (
                        <Row key={item.label}>
                            <div className={classnames('base-map-switch-list-label')}>
                                {item.label}
                            </div>

                            <div className={classnames('base-map-switch-list-item-wrap')}>
                                <Row gutter={[12, 12]}>
                                    {item.children.map(v => (
                                        <Col span={12} key={`${item.label}-${v.label}`}>
                                            <div
                                                onClick={() => onChange(item, v)}
                                                className={classnames('base-map-switch-list-item', {
                                                    'base-map-switch-list-item-active':
                                                        value?.value === `${item.value}_${v.value}`,
                                                })}
                                            >
                                                <img
                                                    className={classnames(
                                                        'base-map-switch-list-item-img',
                                                    )}
                                                    src={v.img}
                                                    alt=""
                                                />
                                                <div
                                                    className={classnames(
                                                        'base-map-switch-list-item-label',
                                                    )}
                                                >
                                                    {v.label}
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </Row>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <ItemWrap content={content}>
            {value?.img && (
                <img
                    src={value.img}
                    className={classnames('cs-map-base-map-switch-active')}
                    alt=""
                />
            )}
        </ItemWrap>
    );
}
